import React from 'react';
import { FormGroup, FormLabel, FormControl } from 'react-bootstrap';
import { useTheme } from 'styled-components';

interface ReadonlyInputWithEditProps {
  label: string;
  value: string;
  id: string;
  onEdit: () => void;
  multiline?: boolean;
  rows?: number;
  style?: React.CSSProperties;
  textAlign?: 'left' | 'center' | 'right' | 'justify';
  iconColor?: string;
}

const ReadonlyInputWithEdit: React.FC<ReadonlyInputWithEditProps> = ({
  label,
  value,
  id,
  onEdit,
  multiline = false,
  rows = 2,
  style,
  textAlign = 'left',
  iconColor,
}) => {
  const theme = useTheme();

  const handleClick = () => {
    if (onEdit) onEdit();
  };

  return (
    <FormGroup controlId={id}>
      <FormControl
        as={multiline ? 'textarea' : 'input'}
        readOnly
        value={value}
        style={{
          borderRadius: '10px',
          border: `1px solid ${theme.colors.bordaInput}`,
          backgroundColor: '#ebf0f8',
          textAlign,
          ...style,
        }}
        {...(multiline ? { rows } : {})}
      />
      <div
        onClick={handleClick}
        style={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          gap: '8px',
          width: '100%',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          marginTop: '8px',
        }}
      >
        <FormLabel
          style={{ color: theme.colors.botaoConfirmar, marginBottom: '8px' }}
        >
          {label}
        </FormLabel>
        <span
          className="material-icons"
          style={{
            fontSize: '20px',
            color: iconColor || 'white',
            userSelect: 'none',
            backgroundColor: theme.colors.botaoConfirmar,
            borderRadius: '32px',
            padding: '8px 8px',
            marginBottom: '8px',
          }}
        >
          edit
        </span>
      </div>
    </FormGroup>
  );
};

export default ReadonlyInputWithEdit;
